import { ReactSelectInput } from '@hivebrite/design-system/Inputs';

import { useGetCategories } from 'hb-react/backoffice/components/CategoriesList/v2/hooks/useGetCategories';
import { makeConfigUrls } from 'hb-react/backoffice/components/CategoriesList/v2/utils/configUrls';
import type { Network } from 'hb-react/types';

interface ReactSelectCategoriesProps {
  categorizedType: string;
  networkId: Network['id'];
  topicId?: number;
  id: string;
  name: string;
  [s: string]: any; // ReactSelectProps
}

const ReactSelectCategories = ({
  categorizedType,
  networkId,
  topicId,
  id,
  name,
  ...props
}: ReactSelectCategoriesProps) => {
  const configUrls = makeConfigUrls({
    networkId,
    type: categorizedType,
    topicId,
  });

  const { categories = [], isLoading } = useGetCategories({
    configUrls,
    type: categorizedType,
    topicId,
    networkId,
    hasPagination: false,
  });

  const options = categories?.map(({ name, id }) => ({
    value: id,
    label: name,
  }));

  return (
    <ReactSelectInput
      {...props}
      id={id}
      name={name}
      options={options}
      isLoading={isLoading}
    />
  );
};

export default ReactSelectCategories;
